import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function AddThick({
  fillPrimary = colors.blue40,
  className,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[14px] w-[14px]', className)}
    >
      <path
        d="M-0.0078125 7.35938C-0.0078125 7.08333 0.0911458 6.84635 0.289062 6.64844C0.486979 6.45052 0.723958 6.35156 1 6.35156H5.60156V1.75781C5.60156 1.48177 5.69792 1.24479 5.89062 1.04688C6.08333 0.848958 6.32031 0.75 6.60156 0.75C6.8776 0.75 7.11458 0.848958 7.3125 1.04688C7.51042 1.24479 7.60938 1.48177 7.60938 1.75781V6.35156H12.2109C12.4818 6.35156 12.7161 6.45052 12.9141 6.64844C13.112 6.84635 13.2109 7.08333 13.2109 7.35938C13.2109 7.64062 13.112 7.88021 12.9141 8.07812C12.7161 8.27083 12.4818 8.36719 12.2109 8.36719H7.60938V12.9688C7.60938 13.2396 7.51042 13.474 7.3125 13.6719C7.11458 13.8698 6.8776 13.9688 6.60156 13.9688C6.32031 13.9688 6.08333 13.8698 5.89062 13.6719C5.69792 13.474 5.60156 13.2396 5.60156 12.9688V8.36719H1C0.723958 8.36719 0.486979 8.27083 0.289062 8.07812C0.0911458 7.88021 -0.0078125 7.64062 -0.0078125 7.35938Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
